import _ from 'lodash';
import { i18n } from '@/i18n';
import allModelData from '@/admin_models/all';
import moment from 'moment';

export const modelData = _.merge({}, allModelData, {
  'User': {
    label: (object) => { return `${object.screen_name}${object.is_block ? '(已冻结)' : ''}`; }
  },
  'CustomerChannel': {
    label: (object) => { return `${object.channel.name}(no: ${object.no || '-'})`; }
  },
  'JushuitanShop': {
    label: 'shop_name'
  },
  'CustomerJushuitanOrderRelation': {
    label: (object) => {
      const jushuitanOrderForeignKey = i18n.t(`customerJushuitanOrderRelation.jushuitanOrderForeignKeys.${object.jushuitan_order_foreign_key}`)

      return `${_.get(object, 'customer.name')} - ${jushuitanOrderForeignKey} - ${object.jushuitan_order_foreign_key_value}`
    }
  },
  'JushuitanOrder': {
    label: (object) => {
      if (_.get(object, 'customer.name')) {
        return `订单号: ${object.o_id} 线上订单号: ${object.so_id} (金额: ${object.amount}, 客户名称: ${_.get(object, 'customer.name')})`
      }

      return `订单号: ${object.o_id} 线上订单号: ${object.so_id} (金额: ${object.amount})`
    }
  },
  'JushuitanAfterSale': {
    label: (object) => {
      return `售后单号: ${object.as_id} (金额: ${object.refund})`
    }
  },
  'TaskAssignment': {
    label: 'task_title'
  },
  'JushuitanInventoryOut': {
    label: (object) => {

      return `出库单号: ${_.get(object, 'io_id') || '-'} (聚水潭订单号: ${_.get(object, 'o_id')})`
    }
  },
  'Payment': {
    label: (object) => {
      return `收款单号: ${object.number} (流水号: ${object.serial_number}, 金额: ${object.amount})`
    }
  },
  'SalesLineItem': {
    label: (object) => {
      if (_.get(object, 'cost')) {
        return `款号: ${object.style_number} (单价: ${object.price}, 数量: ${object.quantity}, 成本: ${object.cost})`
      }

      return `款号: ${object.style_number} (单价: ${object.price}, 数量: ${object.quantity})`
    }
  },
  'PaymentAccount': {
    label: (object) => {
      if (!object.code) {
        return object.name
      }

      return `${object.name} (代码: ${object.code})`
    }
  },
  'FollowRecord': {
    label: (object) => {
      return `${object.customer.name} (${moment(object.followed_at).format('YYYY-MM-DD HH:mm')})`
    }
  },
  'SalesOrder': {
    label: (object) => {
      return `订单号: ${object.number} (客户: ${object.customer.name}, 金额: ${object.sales_amount})`
    }
  },
})

export const displayText = (object) => {
  if (object.cn) {
    const label = modelData[object.cn]['label']

    if (typeof label === 'function') {
      return label(object)
    } else {
      return object[label]
    }
  }
}
